@if (isIbaActive && ((customer.CustomerName != null || customer.CalculatedName != null) || customer.CustomerNumber != null)) {
  <span class="{{ getIdentificationStatus() }}"></span>
}

@if (showCustomerNumber) {
  <span>
    <a (click)="routeToCustomer(getCustomerId())" class="clickable-customer-number">
      {{ customer.CustomerType == 1 ? customer.CustomerName ?? customer.Name : customer.CalculatedName }} - {{ customer.CustomerNumber }}
    </a>
  </span>
} @else {
  <a (click)="routeToCustomer(getCustomerId())" class="clickable-customer-name">{{ customer.CalculatedName }}</a>
}


